module.exports = __webpack_public_path__ + "static/img/robot-red-x1.5d9bb7b.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/robot-red-x1.png
// module id = 3Alc
// module chunks = 1